import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { Modal } from "react-bootstrap";
import Button from "../../../components/button";
import Input from "../../../components/input";
import { fetchConfiguration, updateConfiguration } from "../../../api/endpoint";
import toast from "react-hot-toast";
import axios from "axios";
import Loader from "../../../components/loader";

const UpdateAllModal = ({
  isUpdateAllOpen,
  closeUpdateAllModal,
  fetchPlans,
}) => {
  const [settings, setSettings] = useState({});
  const [loading, setLoading] = useState(false);
  const { auth } = useSelector((state) => state.login);

  useEffect(() => {
    getConfiguration();
  }, []);

  const getConfiguration = async () => {
    try {
      setLoading(true);
      const response = await axios.get(fetchConfiguration, {
        headers: { Authorization: `Bearer ${auth}` },
      });
      setSettings(response?.data);
    } catch (error) {
      toast.error("Error fetching payment configuration");
      console.error("Error fetching payment configuration", error);
    } finally {
      setLoading(false);
    }
  };

  const updateConfig = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      const response = await axios.post(updateConfiguration, settings, {
        headers: { Authorization: `Bearer ${auth}` },
      });
      getConfiguration();
      toast.success("Configuration Updated Successfully");
      closeUpdateAllModal();
      fetchPlans();
    } catch (error) {
      toast.error("Error Updating Configuration");
      console.error("Error Updating Configuration", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Modal show={isUpdateAllOpen} onHide={closeUpdateAllModal} centered>
        <Modal.Header closeButton>
          <Modal.Title>Update Configuration</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Input
            label="Trial Duration in Days"
            name="trialUserDuration"
            placeholder="Enter User Trial Duration"
            type="text"
            value={settings?.trialUserDuration}
            onChange={(e) =>
              setSettings({ ...settings, trialUserDuration: e.target.value })
            }
            className="mb-2"
          />
          <Input
            label="Create Game Price"
            name="createGamePrice"
            placeholder="Enter Price for Creating a Game"
            type="text"
            value={settings?.createGamePrice}
            onChange={(e) =>
              setSettings({ ...settings, createGamePrice: e.target.value })
            }
            className="mb-2"
          />
          <Input
            label="Join Game Price"
            name="joinGamePrice"
            placeholder="Enter Price for Joining a Game"
            type="text"
            value={settings?.joinGamePrice}
            onChange={(e) =>
              setSettings({ ...settings, joinGamePrice: e.target.value })
            }
            className="mb-2"
          />
          <Input
            label="Search distance (in meters)"
            name="searchDistance"
            placeholder="Enter search distance for courts"
            type="text"
            value={settings?.searchDistance}
            onChange={(e) =>
              setSettings({ ...settings, searchDistance: e.target.value })
            }
            className="mb-2"
          />
        </Modal.Body>
        <Modal.Footer>
          <div className="text-end">
            <Button
              text="Update Configuration"
              callBack={(e) => updateConfig(e)}
            />
          </div>
        </Modal.Footer>
      </Modal>
      {loading && <Loader />}
    </>
  );
};

export default UpdateAllModal;
